// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"styles_footerContainer__1cI6x"};